// (Copyright) Confluent, Inc.
import { type ReactNode } from 'react';
import styled from 'styled-components';

type ContentPanelStyles = {
  children?: ReactNode;
  css?: string;
  // TODO: remove unused deemphasize prop
  deemphasize?: boolean;
  fullWidth?: boolean;
  height?: string;
  width?: string;
  withBottomBar?: boolean;
};

const ContentPanel = styled.div.attrs(() => ({
  'data-test': 'ContentPanel',
}))<ContentPanelStyles>`
  height: ${({ height }) => (height != null ? height : '')};
  width: ${({ width }) => (width != null ? width : '')};
  padding-top: 7px;
  padding-bottom: 44px;
  ${({ withBottomBar }) => (withBottomBar ? 'margin-bottom: var(--BOTTOMBAR_HEIGHT);' : '')};
`;

ContentPanel.displayName = 'ContentPanel';

ContentPanel.defaultProps = {
  deemphasize: false,
};

const ContentPanelExport = ContentPanel;
export default ContentPanelExport;
